import Phaser from 'phaser';
import IceCreamData from '../IceCreamData';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import { dotPop } from '../Utils';
import { playJingle } from '../SoundManager';
import GameScreen from './GameScreen';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import FontKeys from '../FontKeys';
import LocalizationUIAssets from '../Localization-UIAssets';

export default class TitleScreen extends Phaser.Scene {
  static get KEY() { return 'TitleScreen'; }

  constructor() {
    super({ key: TitleScreen.KEY });
  }

  create() {
    playJingle();

    ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._LandscapeMainBackground_4x3, this).setOrigin(0);

    const introtreats = IceCreamData.introSprites;
    let sprite = null;

    /** @type {Phaser.GameObjects.Image[]} */
    this.introTreats = [];
    for (let i = 0; i < introtreats.length; i++) {
      const t = introtreats[i];
      sprite = ABCyaPhaser.Images.addImage(t.x, t.y, t.sn, this);
      sprite.destX = sprite.x;
      sprite.destY = sprite.y;
      this.introTreats.push(sprite);
    }

    const amplitude = 1;
    const period = 0.75;
    const time = 1000;

    let theTreat = this.introTreats[0];
    theTreat.x = -theTreat.width / 2;
    this.tweenIntroTreat(theTreat, time, amplitude, period);
    theTreat = this.introTreats[4];
    theTreat.x = this.scale.width + theTreat.width / 2;
    this.tweenIntroTreat(theTreat, time, amplitude, period);

    theTreat = this.introTreats[1];
    theTreat.y = this.scale.height + theTreat.height / 2;
    this.tweenIntroTreat(theTreat, time, amplitude, period, time * 0.75);
    theTreat = this.introTreats[3];
    theTreat.y = this.scale.height + theTreat.height / 2;
    this.tweenIntroTreat(theTreat, time, amplitude, period, time * 0.75);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cherry_land, this, 1, false, time / 1000 * 0.75);

    theTreat = this.introTreats[2];
    theTreat.y = -theTreat.height / 2 * 2;
    this.children.bringToTop(theTreat);

    this.waitTween = this.tweenIntroTreat(theTreat, time, amplitude, period, time * 1.25);
    this.waitTween.on(Phaser.Tweens.Events.TWEEN_UPDATE, this.onMiddleUpdate, this);

    this.btnGo = this.add.container(0,0).setSize(172, 172);
    const btnGoBg = this.add.circle(0,0,86, 0x96c409);
    this.btnGo.add(btnGoBg);
    ABCyaPhaser.Container.setContainerInteractive(this.btnGo, false);
    const btnGoTxt = ABCyaPhaser.Text.addText(0,0,62, 0xffffff,FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('title_screen.go_button'), this.btnGo);
    ABCyaPhaser.Text.resizeFontToFitWidth(btnGoTxt, btnGoBg.width - 20);
    this.btnGo.x = this.scale.width / 2;
    this.btnGo.y = this.scale.height / 2 + (this.btnGo.height * 0.25);

    this.btnGo.alpha = 0;
    this.btnGo.once(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.clickGo, this);

    this.title = ABCyaPhaser.Images.addImage(this.scale.width / 2,170,LocalizationUIAssets._Title, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    this.title.setAlpha(0).setScale(0.25);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._slide_long, this);
  }

  tweenIntroTreat (sprite, time, amp, period, wait) {
    // eslint-disable-next-line no-param-reassign
    sprite.startX = sprite.x;
    // eslint-disable-next-line no-param-reassign
    sprite.startY = sprite.y;
    return ABCyaPhaser.Tweens.addTween(sprite, time, { delay: wait ?? 0, x: sprite.destX, y: sprite.destY, easeParams: [amp, period] }, Phaser.Math.Easing.Elastic.Out);
  }

  onMiddleUpdate () {
    if (this.waitTween && this.introTreats[2].y > this.scale.height / 2) {
      this.btnGo.scale = 0;
      this.time.delayedCall(250, () => dotPop(this.btnGo));

      ABCyaPhaser.Tweens.addTween(this.title, 500, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
      ABCyaPhaser.Tweens.addTween(this.title, 500, { scale: 1 }, Phaser.Math.Easing.Back.Out);
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._Make_an_Ice_Cream, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._appear_pop, this);

      this.btnGo.alpha = 1;
      this.waitTween.off(Phaser.Tweens.Events.TWEEN_UPDATE, this.onMiddleUpdate, this);
      this.waitTween = null;
    }
  }

  clickGo () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    this.outroTween();
  }

  outroTween () {
    const time = 640;

    ABCyaPhaser.Tweens.addTween(this.btnGo, time, { scale: 1.2, alpha: 0, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);

    const theTreat = this.introTreats[2];
    this.tweens.killTweensOf(theTreat);
    this.waitTween = ABCyaPhaser.Tweens.addTween(theTreat, time, { x: theTreat.startX, y: theTreat.startY, easeParams: [1, 0.75] }, Phaser.Math.Easing.Elastic.In);
    this.waitTween.on(Phaser.Tweens.Events.TWEEN_UPDATE, this.onMiddleOutUpdate, this);
    this.outWait = this.waitTween;
  }

  onMiddleOutUpdate () {
    if (this.outWait && this.introTreats[2].y <= this.scale.height / 2 + 250) {// 250 is for scoop height
      this.waitTween.off(Phaser.Tweens.Events.TWEEN_UPDATE, this.onMiddleOutUpdate, this);
      this.waitTween = null;
      this.outWait = null;
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._slide_whistle_down, this);

      const y = -this.title.height * 0.5;

      this.tweens.killTweensOf(this.title);
      ABCyaPhaser.Tweens.addTween(this.title,340, { y, easeParams: [1, 0.75], completeDelay: 250 }, Phaser.Math.Easing.Elastic.In, () => {
        this.nextScene();
      });

      ABCyaPhaser.Tweens.addTween(this.title, 220, { delay: 340 * 0.75, alpha: 0 }, Phaser.Math.Easing.Linear);

      const time = 280;
      let theTreat = this.introTreats[0];
      this.tweenOutroTreat(theTreat, time, time * 0.25);
      theTreat = this.introTreats[4];
      this.tweenOutroTreat(theTreat, time, time * 0.25);
      theTreat = this.introTreats[1];
      this.tweenOutroTreat(theTreat, time);
      theTreat = this.introTreats[3];
      this.tweenOutroTreat(theTreat, time);
    }
  }

  nextScene () {
    this.destroy();

    this.scene.start(GameScreen.KEY);
  }

  destroy () {
    this.tweens.killAll();
    this.introTreats = [];
  }

  tweenOutroTreat (sprite, time, wait) {
    this.tweens.killTweensOf(sprite);
    return ABCyaPhaser.Tweens.addTween(sprite, time, { x: sprite.startX, y: sprite.startY, delay: wait ?? 0 }, Phaser.Math.Easing.Quadratic.Out);
  }
}